module.exports = __webpack_public_path__ + "static/media/SEO_Certificate.90d1617b.png";